module.exports = __webpack_public_path__ + "media/cuu/sec_educacion_deporte_cuu-4e9aac17.png";